import { useCallback, useEffect, useMemo, useState, type ReactNode } from 'react'

import { onSessionExpired, refreshSession, setAccessToken, type TokenOut } from '../api/client'
import { endpoints } from '../api/endpoints'
import { SessionContext, type Status } from './context'

export function SessionProvider({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<Status>('loading')

  useEffect(() => {
    onSessionExpired(() => setStatus('anonymous'))
    // A reload keeps the owner signed in through the refresh cookie.
    void refreshSession().then((ok) => setStatus(ok ? 'signed_in' : 'anonymous'))
  }, [])

  const signedIn = useCallback((out: TokenOut) => {
    setStatus(out.password_must_change ? 'must_change_password' : 'signed_in')
  }, [])

  const logout = useCallback(async () => {
    try {
      await endpoints.logout()
    } finally {
      setAccessToken(null)
      setStatus('anonymous')
    }
  }, [])

  const value = useMemo(() => ({ status, signedIn, logout }), [status, signedIn, logout])
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
}
